// extracted by mini-css-extract-plugin
export default {"container":"Az_r0BpM","mobile":"mobile","attention":"wZtpAPT6","logos":"YfZD0ncj","title":"c9crs4jE","buttons":"OZ77yK9Q","description":"CqOugkm8","agreement":"b0Pdf3vq"};